import { Button, CircularProgress, Fade } from '@mui/material';

import useSettings from '../../hooks/useSettings';
import Icon from '../../Icon';
import Text from '../../Text';

interface ResultStepProps {
	fileName: string;
	exportFormat: string;
	reportUri?: string;
	reportBlobUrl?: string;
	isProcessing: boolean;
}

export default function ResultStep(props: ResultStepProps) {
	const { t } = useSettings();

	return (
		<div className="flex items-center py-8">
			<div className="mr-12">
				<div className="relative inline-flex">
					<CircularProgress
						value={100}
						size={64}
						variant={props.isProcessing ? 'indeterminate' : 'determinate'}
						color={!props.isProcessing ? 'success' : undefined}
						disableShrink={props.isProcessing}
					/>
					<div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center">
						<Fade in={!props.isProcessing} timeout={500}>
							<div className="flex">
								<Icon icon="check-circle" size={60} color="success.main" />
							</div>
						</Fade>
					</div>
				</div>
			</div>
			<div className="overflow-auto">
				<div className="pb-4">
					<Text variant="subtitle2" gutterBottom>
						{`${props.fileName}.${props.exportFormat}`}
					</Text>
					<Text className="text-ellipsis" variant="subtitle2" color="text.secondary" gutterBottom>
						{props.reportUri}
					</Text>
				</div>
				<Button
					className="m-4"
					variant="contained"
					href={props.reportBlobUrl || ''}
					download={props.fileName}
					disabled={props.isProcessing || !props.reportBlobUrl}
				>
					{t('REPORTING_BUTTON_DOWNLOAD')}
				</Button>
				<Button
					className="m-4"
					variant="contained"
					href={props.reportBlobUrl || ''}
					target="_blank"
					disabled={props.isProcessing || !props.reportBlobUrl}
				>
					{t('REPORTING_BUTTON_VIEW')}
				</Button>
			</div>
		</div>
	);
}
